import { Box, Typography, Paper } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../assets/img/info-icon.svg';
import PieChart from '../Graphs/PieChart';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { ErrorState } from '../common/ErrorState';
import { NoDataState } from '../common/NoDataState';

export const SpeciesData = (props: any) => {
  const { isLoading, isError, error, hasData, rows, totalBirdsDetected, totalSpeciesDetected } = props;

  // Show loading state
  if (isLoading) {
    return (
      <Paper 
        className="custom-chart"
        sx={{ 
          minWidth: '1000px', 
          maxWidth: '100%', 
          overflow: 'hidden', 
          marginBottom: '7px', 
          padding: '20px',
          borderRadius: '16px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(229, 231, 235, 0.8)',
          background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
        }}>
        <LoadingSpinner 
          message="Loading species data..." 
          height="600px"
          showBackground={false}
        />
      </Paper>
    );
  }

  // Show error state
  if (isError) {
    return (
      <Paper 
        className="custom-chart"
        sx={{ 
          minWidth: '1000px', 
          maxWidth: '100%', 
          overflow: 'hidden', 
          marginBottom: '7px', 
          padding: '20px',
          borderRadius: '16px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(229, 231, 235, 0.8)',
          background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
        }}>
        <ErrorState 
          title="Failed to load species data"
          error={error}
          height="600px"
          showBackground={false}
          onRetry={props.onRetry}
        />
      </Paper>
    );
  }

  // Show no data state
  if (!hasData) {
    return (
      <Paper 
        className="custom-chart"
        sx={{ 
          minWidth: '1000px', 
          maxWidth: '100%', 
          overflow: 'hidden', 
          marginBottom: '7px', 
          padding: '20px',
          borderRadius: '16px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(229, 231, 235, 0.8)',
          background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
        }}>
        <NoDataState 
          title="No species data available"
          message="No species data found for the selected date range and filters. Try adjusting your selection criteria."
          height="600px"
          showBackground={false}
        />
      </Paper>
    );
  }

  return (
    <Paper 
      className="custom-chart"
      sx={{ 
        minWidth: '1000px', 
        maxWidth: '100%', 
        overflow: 'hidden', 
        marginBottom: '7px', 
        padding: '20px',
        borderRadius: '16px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(229, 231, 235, 0.8)',
        background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
      }}>
      <Box className="species-header">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '23px',
            padding: '20px',
            marginBottom: '30px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '11px',
              alignItems: 'center',
              paddingTop: '7px',
            }}
          >
            <InfoIcon />
            <Box
              sx={{
                borderLeft: '2px solid #45009C',
                height: '108px',
              }}
            ></Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingBottom: '25px',
                gap: '10px',
              }}
            >
              <Typography sx={{ color: '#17052D' }} variant="h6">
                Species data
              </Typography>
              <Typography
                sx={{ color: '#8B8296', fontSize: '14px' }}
                variant="body2"
              >
                This pie chart shows the breakdown of different species detected
                in the selected date range
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: '40px' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}
              >
                <Typography
                  sx={{ color: '#17052D;', fontSize: '20px' }}
                  variant="h3"
                >
                  {totalBirdsDetected}
                </Typography>
                <Typography
                  sx={{ color: '#8B8296', fontSize: '14px' }}
                  variant="body2"
                >
                  Birds detected
                </Typography>
              </Box>
              {totalSpeciesDetected ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Typography
                    sx={{ color: '#17052D;', fontSize: '20px' }}
                    variant="h3"
                  >
                    {totalSpeciesDetected}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#8B8296',
                      fontSize: '14px',
                      paddingLeft: '2px',
                    }}
                    variant="body2"
                  >
                    Birds identified
                  </Typography>
                </Box>
              ) : (
                <></>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: 400 }}>
        <PieChart rows={rows} />
      </Box>
    </Paper>
  );
};
